import { library } from '@fortawesome/fontawesome-svg-core';
import { faBullseye, faDrawPolygon, faLongArrowAltRight, faMousePointer, faPaintBrush, faSlash, faVectorSquare } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { observer } from 'mobx-react-lite';
import { ReactElement } from 'react';
import { AnnotationToolType } from '../modules/annotation/submodules/annotationTypes/models/annotationToolType';

library.add(faBullseye, faDrawPolygon, faVectorSquare, faLongArrowAltRight, faSlash, faMousePointer);

const ICONS = {
  Select: faMousePointer,
  Point: faBullseye,
  Rectangle: faVectorSquare,
  Polygon: faDrawPolygon,
  Vector: faLongArrowAltRight,
  Polyline: faSlash,
  RotatedRectangle: faVectorSquare,
  Brush: faPaintBrush,
} as const;

interface IProps {
  toolType: AnnotationToolType;
}

export const ToolTypeIcon = observer((props: IProps): ReactElement => {
  if (props.toolType === AnnotationToolType.ROTATEDRECTANGLE) {
    return (
      <FontAwesomeIcon
        icon={ICONS[props.toolType]}
        className='icon rotate30'
      />
    );
  }
  return (
    <FontAwesomeIcon
      icon={ICONS[props.toolType]}
      className='icon'
    />
  );
});
